// library
import { FC } from "react";
import { Link } from "react-router-dom";

const Header: FC<any> = ( props: { setIsOpenPrefecture: any, isSettingDisplay: boolean, setSelectSightseeing: any}) => {

    const { setIsOpenPrefecture, isSettingDisplay, setSelectSightseeing } = props;

    const openDialog = () => {
        setIsOpenPrefecture(true);
        setSelectSightseeing(null);
    }

    return (
        <>
            <header>
                <div className="app-bar">
                    <div className="title-logo-wrapper">
                        <Link to="/">
                            <img
                                className="title-log"
                                src={"./icons/title-logo.svg"}
                                height={24}
                                alt="イベントマップタイトル"
                                style={{ cursor: 'pointer' }}
                            />
                        </Link>
                    </div>
                    <div className="main-title-wrapper">
                        <div className="main-title">
                            <img
                                className="icon-calender"
                                src={"./icons/calender.svg"}
                                height={15}
                                alt="イベントマップカレンダー"
                            />
                            <h1>イベントマップ</h1>
                        </div>
                        <h2>近くのイベントをすぐチェック</h2>
                    </div>
                    <div className="setting-logo-wrapper">
                        {isSettingDisplay &&
                            <img 
                                className="setting-logo"
                                src={"./icons/setting-logo.svg"}
                                height={25} 
                                alt="セッテイングボタン" 
                                onClick={openDialog}
                                style={{ cursor: 'pointer' }}
                            />
                        }
                        {!isSettingDisplay &&
                            <Link to="/">
                                <img 
                                    className="setting-logo"
                                    src={"./icons/return-logo.svg"}
                                    height={23} 
                                    alt="戻るボタン" 
                                    style={{ cursor: 'pointer' }}
                                />
                            </Link>
                        }
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;